<template>
  <div class="products-container">
    <nav-bar></nav-bar>
    <div class="container second-container">
      <div class="columns is-vcentered custom-vertical-space">
        <div class="column is-12"></div>
      </div>
      <div class="columns">
        <div class="column is-10-fullhd is-offset-1-fullhd products-title">
          <div class="content">
            <h1 class="is-uppercase has-text-centered has-text-primary">
              {{ texts.pageTitle }}
            </h1>
          </div>
        </div>
      </div>
      <div class="column is-12-fullhd">
        <div class="columns">
          <!-- <div class="column is-three-quarters products-title"> -->
          <div class="column  products-title">
            <div class="content">
              <p v-html="texts.paragraph1"></p>
              <p v-if="isExpanded" v-html="texts.paragraph2"></p>
              <p v-if="isExpanded" v-html="texts.paragraph3"></p>
              <p v-if="isExpanded" v-html="texts.paragraph4"></p>
              <p v-if="isExpanded" v-html="texts.paragraph5"></p>
              <p v-if="isExpanded" class="has-text-weight-bold">{{ texts.fourthRow }}</p>
              <ul v-if="isExpanded">
                <li v-for="(li, index) in unorderedList" :key="index">{{ li }}</li>
              </ul>
            </div>
          </div>

          <ProductCategories></ProductCategories>
          
        </div>
      </div>
    </div>

    <div class="container second-container">
      <div class="columns is-vcentered custom-vertical-space">
        <div class="column is-12 has-text-centered">
          <img v-if="isMobileView" class="arrow" :src="arrowImgSrc" width="12px" heigth="14px" alt="arrow"
            @click="expandDescription" />
        </div>
      </div>
    </div>

    <div class="container second-container productsPaginationContainer" id="productsPaginationContainer">
      <PaginationContainer :products="products" :currentPage="currentPage" :productFound="texts.productFound"
        :allProducts="texts.all" />
    </div>

    <app-footer></app-footer>
  </div>
</template>
<script>
import NavBar from "./Navbar.vue";
import AppFooter from "./AppFooter.vue";
import ProductCategories from "./ProductCategories.vue";
import detachableTrailers from "../assets/detachableTrailers";
import PaginationContainer from "./PaginationContainer";

export default {
  data() {
    return {
      products: detachableTrailers,
      currentPage: 1,
      publicPath: process.env.BASE_URL,
      index: null,
      currentOffset: 0,
      dragging: false,
      isDescriptionExpanded: false,
      doubleArrowDown: require("../assets/images/double_arrow_down.svg"),
      doubleArrowUp: require("../assets/images/double_arrow_up.svg"),
    };
  },
  created() {
    let url_string = window.location.href; //window.location.href
    let url = new URL(url_string);
    let setParameterInUrl = url.searchParams.get("set");
    if (this.getSetParameterFromUrl() == null) {
      this.currentPage = 1;
    } else {
      this.currentPage = Number(this.getSetParameterFromUrl());
    }
  },
  components: {
    NavBar: NavBar,
    AppFooter: AppFooter,
    PaginationContainer: PaginationContainer,
    ProductCategories: ProductCategories
  },
  computed: {
    texts() {
      return this.$t("products.detachableTrailers");
    },
    introTexts() {
      return this.$t("homePage");
    },
    isMobileView: {
      get() {
        if (window.innerWidth < 768) {
          return true;
        } else {
          return false;
        }
      },
    },
    arrowImgSrc: {
      get() {
        if (this.isExpanded) {
          return this.doubleArrowUp;
        } else {
          return this.doubleArrowDown;
        }
      },
    },
    isExpanded() {
      if (!this.isMobileView) {
        return true;
      } else {
        if (this.isDescriptionExpanded) {
          return true;
        } else {
          return false;
        }
      }
    },
  },
  beforeRouteUpdate(to, from, next) {
    this.setCurrentPage(to.query["set"]);
    next();
  },
  methods: {
    setCurrentPage(parameter) {
      let page = 1;
      if (parameter != null) {
        page = parseInt(parameter, 10);
      }
      this.currentPage = page;
    },
    getSetParameterFromUrl() {
      let url_string = window.location.href; //window.location.href
      let url = new URL(url_string);
      return url.searchParams.get("set");
    },
    expandDescription() {
      console.log("click a nyilra");
      if (this.isDescriptionExpanded == false) {
        this.isDescriptionExpanded = true;
      } else {
        this.isDescriptionExpanded = false;
      }
    },
  },
  mounted() {
    this.$watch("$refs.carousel.currentOffset", function (new_value) {
      this.$data.currentOffset = -new_value;
      this.$data.dragging = this.$refs.carousel.dragging;
    });
    // this.unorderedList = this.$t("products.mobilehouse.ul");
  },
};
</script>
<style lang="scss" scoped>
.carousel-header {
  position: relative;
  z-index: 1000;
  background-color: white;
}

.card {
  border: 1px solid #266e79;
  border-bottom: 0px;
}

.card-content {
  text-align: center;
  padding: 0;

  h3 {
    padding-bottom: 10%;
    color: #00323d;
    border-bottom: 1px solid #266e79;
  }

  p {
    border-bottom: 1px solid #266e79;
    color: #00323d;
  }
}

.card .image img {
  padding: 25px;
}

.orange {
  color: #e56a25;
}

.products-anchor:hover {
  img {
    transform-origin: center 58%;
    transition: 0.3s ease-out;
    transform: scale(1.02);
  }
}

.products-anchor {
  img {
    transition: 0.3s ease-out;
  }

  .image {
    padding: 8% 0;
  }

  .image img {
    min-width: 128px;
    max-width: 75%;
  }
}

.image p {
  position: absolute;
  right: 0;
  left: 0;
  text-align: center;
  color: #fff;
  z-index: 35;
  transition: 0.3s ease-out;
  text-transform: uppercase;
  font-size: 0.7em;
  max-width: 80%;
  margin: 0 auto;
  top: 50%;
  transform: translateY(-50%);
}

.products-container .description2 {
  margin: 7.5rem auto 2rem;
}

@include mobile {
  .image {
    display: flex;

    img {
      margin: 0 auto;
    }
  }

  .card-content h3 {
    padding-bottom: 3%;
  }
}

.subtitleWithLogo {
  justify-content: center;
  align-items: center;
  margin-top: 2rem;

  .customSubtitle {
    line-height: 2.5rem;
    margin: 0 0 0 1rem;
    font-style: none;
  }

  img {
    height: 1.9rem;
    width: auto;
  }

  @media (max-width: 600px) {
    align-items: center;
    flex-direction: column;

    .customSubtitle {
      margin: 0 1rem 0 0;
    }
  }
}

.subtitleWithLogo .content .customSubtitle {
  margin-top: 0;
}

.additionalComponent {
  margin-bottom: 1rem;
}

.additionalComponent.orange {
  margin-bottom: 0.6rem;
}

.productsPaginationContainer {
  padding-top: 5rem;
  margin-bottom: 3rem;
}

.arrow {
  width: 30px;
  cursor: pointer;
}

@media (max-width: 768px) {
  .products-container .description2 {
    margin: 1rem auto 2rem;
    padding: 0 35px;
  }

  .productsPaginationContainer {
    padding-top: 3rem;
    margin-bottom: 3rem;
  }
}
</style>
